/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:23
 * @LastEditTime: 2021-04-13 15:11:51
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\MC\messageCenter.js
 * @Description: 消息中心
 */
angular.module('messageCenterModule', [
    'messageCenterRouterModule', // 消息中心路由
    'messageCenterLeftModule',
    'MCmessageModule', // 消息中心-消息
    'messageCNoticeModule', // 消息中心-通知公告
    'messageCenterServiceModule', // 判断是否已读服务
    'messageCNoticeModule', // 消息中心-通知公告
    'messageCenterSocketModule', // socket模块
    'timeShowFormatModule'
]).controller('messageCenterCtrl', ['publicToolService', 'messagePublishService', function(publicToolService, messagePublishService) {
    publicToolService.queryModeconfiguration('messageCenter');
    // publicToolService.queryModeconfiguration('messageCenter').then(() => { // 获取版权资源的配置项
    //     messagePublishService.publish('messageCenter.getConfig'); // 为了解决异步问题
    // });
}]);
